import styled from 'react-emotion';

const FilterRow = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  min-height: 50px;
`;

export default FilterRow;
